import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import axios1 from 'axios';
import URLS from 'src/URL.json';
import { setAllowPermission, storeEventLink, storeEventTitle, storeEventType, storeStudioId, storeVdiPresent } from './waitingAV';
import { BrandingData, handleIsCollabAvailable, setConference, setSession, setWaitingUser } from './persistStore';
import { getVDIPresenter } from './editor';
import { handleRefreshToken } from 'src/services/UserService';
import { extractCode } from 'src/helpers/get-invite-code';
import jwt_decode from "jwt-decode";
import { handleRaiseHandStatus } from './AvToolbar';
import createGuest from "cross-domain-storage/guest";
import { extractNumberFromMessage } from 'src/helpers/fetchNumber';
import { meetingActions } from './meeting';

interface IBranding {
  enabled?: boolean;
  name?: string;
  logo?: string;
  tagline?: string;
  links?: {
    privacy?: string;
    terms?: string;
  };
  callback?: string;
  customDomain?: {
    enabled?: boolean;
    domain?: string;
  };
  email?: string;
}
interface IWaitingRoom {
  eventId: string
  sessionToken: string
  sessionverifiedToken: string
  ptoken: string
  waitingmessage: string
  ftoken: string
  status: string
  blockUserStatus: boolean
  Accesstoken: string
  checkLogin: boolean;
  checkMessage1: boolean;
  // email:string,
  // password:string
  waitingDialog: {
    token: string
    name: string
    participant_id: string
    participant_email: string,
    isInvited?: boolean
  }[]
  creditDialog: {
    active: boolean
    message: string
    url: string
  }
  insufficientCredits: {
    active: boolean
    message: string
    serviceName: string
  }
  notificationSound: boolean
  eventName?: string;
  raiseHand: {
    active: boolean;
    value: {
      name: string;
      participant_id: string;
      sequence?: number; // Make sequence property optional
    }[];
  };
  userReaction: {
    active: boolean
    value: {
      reaction: string
      participant_id: string
    }[]
  }
  timeLeft: number;
  branding: IBranding;
  linkExpiry?: {
    linkExpired?: boolean;
    expiryType?:
      | "notStarted"
      | "expired"
      | "invalidOrCodeExpired"
      | "eventFull"
      | "invalidEventId";
  };
  leaveBtnLoading?: boolean;
  openParallelMeetingModel: boolean;
  openParticipantLimitModel: boolean;
  openPlanUpgraded: boolean;
  playbookCompleted: boolean;
  playbookCompletedVP: boolean;
  playbookCorrupt: boolean;
  sessionActiveConflict: boolean;
  isEventDataLoaded: boolean;
  waitingRoomNotAllowed: boolean;
  usedByAnotherUser: boolean;
  eventNotPublished: boolean;
}

const initialState: IWaitingRoom = {
  eventId: '',
  sessionToken: '',
  sessionverifiedToken: '',
  ptoken: '',
  waitingmessage: '',
  ftoken: '',
  status: 'failed',
  blockUserStatus: false,
  Accesstoken: '',
  checkLogin: false,
  checkMessage1: false,
  //   email:"",
  //   passsword:"",
  waitingDialog: [],
  notificationSound: false,
  creditDialog: {
    active: false,
    message: '',
    url: '',
  },
  insufficientCredits: {
    active: false,
    message: '',
    serviceName: '',
  },
  eventName: "",
  raiseHand: {
    active: false,
    value: []
  },
  userReaction: {
    active: false,
    value: []
  },
  timeLeft: 5,
  branding: {
    enabled: false,
    name: "",
    tagline: "",
    logo: process.env.REACT_APP_LOADER_LOGO,
    links: {
      privacy: "",
      terms: "",
    },
    callback: "",
    customDomain: {
      enabled: false,
      domain: "",
    },
    email: "",
  },
  linkExpiry: {
    linkExpired: false,
    expiryType: "notStarted",
  },
  leaveBtnLoading: false,
  openParallelMeetingModel: false,
  openParticipantLimitModel: false,
  openPlanUpgraded: false,
  playbookCompleted: false,
  playbookCompletedVP: false,
  playbookCorrupt: false,
  sessionActiveConflict: false,
  isEventDataLoaded: false,
  waitingRoomNotAllowed: false,
  usedByAnotherUser: false,
  eventNotPublished: false,
};

const slice = createSlice({
  name: 'Waiting room',
  initialState,
  reducers: {
    createSession(state, action) {
      state.sessionToken = action.payload;
    },
    verifiedToken(state, action) {
      state.sessionverifiedToken = action.payload;
    },
    pollingToken(state, action) {
      state.ptoken = action.payload;
    },
    waitingMessage(state, action) {
      state.ptoken = action.payload;
    },
    finalToken(state, action) {
      state.ftoken = action.payload;
    },
    joinStatus(state, action) {
      state.status = action.payload;
    },
    SetBlockUserStatus(state, action) {
      state.blockUserStatus = action.payload;
    },
    storeeventId(state, action) {
      state.eventId = action.payload;
    },
    AccessToken(state, action) {
      state.Accesstoken = action.payload;
    },
    setCheckLogin(state, action) {
      state.checkLogin = action.payload;
    },
    setCheckMessage1(state, action) {
      state.checkMessage1 = action.payload;
    },
    setDialogData(state, action) {
      if (action.payload.key) {
        if (
          state.waitingDialog.find(
            (val) => val.participant_id === action.payload.value.participant_id,
          )
        ) {
          state.waitingDialog.forEach((val, index) => {
            if (val.participant_id === action.payload.value.participant_id) {
              state.waitingDialog[index].token = action.payload.value.token;
            }
          });
        } else {
          state.waitingDialog.push(action.payload.value);
        }
      } else {
        state.waitingDialog = action.payload.value;
      }
      if (state.waitingDialog?.length === 0) {
        state.notificationSound = false;
      } else if (state.waitingDialog?.length === 1 && !state.notificationSound) {
        state.notificationSound = true;
      }
    },
    removeDialog(state, action) {
      state.waitingDialog = state.waitingDialog.filter(
        (value) => value.participant_id !== action.payload,
      );
    },
    leavingRoom(state, action) {
      state.waitingDialog = state.waitingDialog.filter(
        (value) => value.participant_id !== action.payload,
      );
    },
    storeCreditDialog(state, action) {
      state.creditDialog = action.payload;
    },
    storeInsufficientCredits(state, action) {
      state.insufficientCredits = action.payload;
    },
    setSessionActiveConflict(state, action) {
      state.sessionActiveConflict = action.payload;
    },
    setWaitingRoomNotAllowed(state, action) {
      state.waitingRoomNotAllowed = action.payload;
    },
    setEventNotPublished(state, action) {
      state.eventNotPublished = action.payload;
    },
    setEventName(state, action) {
      state.eventName = action.payload;
    },
    setRaiseHandData(state, action) {
      if (action.payload.raise) {
        state.raiseHand.active = true;
        const existingParticipant = state.raiseHand.value.find(
          (value) => value.participant_id === action.payload.data.participant_id
        );

        if (existingParticipant) {
          // Update existing participant's data
          existingParticipant.sequence = action.payload.data.sequence;
        } else {
          // Add new participant
          state.raiseHand.value.push(action.payload.data);
        }
      } else {
        // Remove participant with the specified participant_id
        state.raiseHand.value = state.raiseHand.value.filter(
          (value) => value.participant_id !== action.payload.data
        );
      }
    },
    

    setRaiseHandDataClose(state, action) {
      state.raiseHand.active = action.payload;
    },
    //user reaction
    setUserReactionData(state, action) {
      const newReaction = action.payload.data;
      const existingIndex = state.userReaction.value.findIndex(
    (r) => r.participant_id === newReaction.participant_id
      );
      if (existingIndex !== -1) {
        state.userReaction.value[existingIndex] = newReaction;
      } else {
        state.userReaction.value.push(newReaction);
      }
    },
    setUserReactionClearData(state,action) {
      const participantId = action.payload;

      if (participantId) {
        state.userReaction.value = state.userReaction.value.filter(
      (reaction) => reaction.participant_id !== participantId
        );
      } else {
        state.userReaction.value = [];
      }
    },
    setTimeLeft(state, action) {
      state.timeLeft = action.payload;
    },
    getBrnadingData(state, action) {
      state.branding = action.payload;
    },
    linkExpiry(state, action) {
      const data = action.payload;
      state.linkExpiry.linkExpired = data?.linkExpired;
      state.linkExpiry.expiryType = data?.expiryType;
    },
    leaveBtnLoading(state, action) {
      state.leaveBtnLoading = action.payload;
    },
    handleActivateParallelMeeting(state, action) {
      state.openParallelMeetingModel = action.payload;
    },
    handleParticipantLimit(state, action) {
      state.openParticipantLimitModel = action.payload;
    },
    setOpenPlanUpgraded(state,action){
      state.openPlanUpgraded = action.payload;
    },
    setPlaybookCompleted(state, action) {
      state.playbookCompleted = action.payload;
    },
    setPlaybookCompletedVP(state, action) {
      state.playbookCompletedVP = action.payload;
    },
    setPlaybookCorrupt(state, action) {
      state.playbookCorrupt = action.payload;
    },
    setEventDataLoaded(state, action) {
      state.isEventDataLoaded = action.payload;
    },
    setUsedByAnotherUser(state, action) {
      state.usedByAnotherUser = action.payload;
    }
  },
});

export const waitinroomActions = slice.actions;

export const reducer = slice.reducer;
const URL =
  process.env.NODE_ENV !== 'production'
    ? URLS.EL_LOCAL_URL
    : process.env.REACT_APP_EL_URL;
const APP_BASE_URL = process.env.REACT_APP_API_URL;
export const EventId = (data) => async (dispatch) => {
  dispatch(slice.actions.storeeventId(data));
};

export const Verify = (data, session) => async (dispatch) => {
  try {
    const eventId = window.location.href.split("/")[4].split('?')[0];
    const verifytoken = {
      token: data,
    };

    const response = await axios.post(
      `${APP_BASE_URL}/aacl/api/v1/session/verify`,
      verifytoken,
    );
    dispatch(slice.actions.setEventName(response?.data?.data?.eventName ?? ""));
    dispatch(slice.actions.verifiedToken(response?.data?.data?.token));
    dispatch(storeEventType(response?.data?.data?.eventType ?? ""));
    if (!response?.data?.data?.token) {
      if (extractCode()) {
        window.location.href = `${URL}/source=play?event=${eventId}&session=${session}&code=${extractCode()}`;
      }
      else {
        window.location.href = `${URL}/source=play?event=${eventId}&session=${session}`;
      }
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const waiting = (sessionverifiedToken, id) => async (dispatch) => {
  try {
    // check for invite code in url search params
    const code = extractCode();
    const query = code ? `?code=${code}` : "";

    const data = {
      eventId: id
    };

    const config = {
      headers: { BearerToken: `${sessionverifiedToken}` },
    };

    const response = await axios.post(
      `${APP_BASE_URL}/events/api/v1/participants/waiting${query}`,
      data,
      config,
    );
    if (!response?.data?.status) {
      if (response?.data?.message === "Event is ended") {
        dispatch(slice.actions.linkExpiry({
            linkExpired: true,
            expiryType: "expired",
        }));
      } else if (response?.data?.message === "Event is not started yet") {
        dispatch(slice.actions.linkExpiry({
            linkExpired: true,
            expiryType: "notStarted",
        }));
      } else if (response?.data?.message === "The given code is either invalid or expired. Please try again") {
        dispatch(slice.actions.linkExpiry({
            linkExpired: true,
            expiryType: "invalidOrCodeExpired",
        }));
      }
       else if (response?.data?.message === "Playbook is already completed") {
        dispatch(slice.actions.setPlaybookCompleted(true));
      } else if (response?.data?.message === "Event is full") {
        dispatch(
          slice.actions.linkExpiry({
            linkExpired: true,
            expiryType: "eventFull",
          }),
        );
      } else if (response?.data?.message === "Playbook is already consumed by other user") {
       dispatch(slice.actions.setUsedByAnotherUser(true));
    }else if (response?.data?.message === "You don't have enough credits to run this playbook") {
        dispatch(slice.actions.storeInsufficientCredits({
          active: true,
          message: "You do not have enough AI credits to start this playbook. Please add more AI credits and try joining the playbook again.",
          serviceName: "playbook"
        }));
      } else if (response?.data?.message === "The host doesn't have enough credits to run this playbook") {
        dispatch(slice.actions.storeInsufficientCredits({
          active: true,
          message: "The host does not have enough AI credits to start this playbook. We've already notified the host. Please try joining again later.",
          serviceName: "playbook-participant"
        }));
      }
   } else {
      dispatch(slice.actions.linkExpiry({
          linkExpired: false,
          expiryType: "notStarted",
      }));
    }

    // I'm finding number from API msg
    const message = response?.data?.message;
    const number = extractNumberFromMessage(message);

    if (response?.data?.status) {
      dispatch(slice.actions.pollingToken(response?.data?.data?.token));
      return true;
    } else {
      localStorage.removeItem('waiting');
      if (message === "You have already running session in other browser") {
        dispatch(slice.actions.setCheckLogin(true));
        dispatch(slice.actions.setCheckMessage1(true));
      } else if (message === "Joining with waiting room is not allowed") {
        dispatch(slice.actions.setCheckLogin(true));
        dispatch(slice.actions.setCheckMessage1(false));
      } else if (message === "You're not allowed to join the event") {
        dispatch(slice.actions.setWaitingRoomNotAllowed(true));
      } else if (message === "You are currently joined in 1. Consider buying more seats") {
        dispatch(slice.actions.handleActivateParallelMeeting(true));
      } else if (message === `You have already added ${number} to the event`) {
        dispatch(slice.actions.handleParticipantLimit(true));
      } else if (message === "Another user is already active in this session") {
        dispatch(slice.actions.setSessionActiveConflict(true));
      } else if (message === "Event is not published yet") {
        dispatch(slice.actions.setEventNotPublished(true));
      }
      return false;
    }
  } catch (error) {
    localStorage.removeItem('waiting');
    window.location.href = URL;
    return false;
  }
};

export const waitingWithRegistration = (id, name, email, ParticipantId) => async (
  dispatch,
) => {
    try {
      // check for invite code in url search params
      const code = extractCode();
      const query = code ? `?code=${code}` : "";
      let data = {};
    if (id === '' && name === '' && email === '' && ParticipantId === '') {
      const tempData = localStorage.getItem('waiting');
        data = JSON.parse(tempData);
      } else {
        data = {
          eventId: id,
          participantId: ParticipantId,
          properties: {
            name: name,
            emailId: email,
          },
        };
      }
      if (data) {
      localStorage.setItem('waiting', JSON.stringify(data));
        const response = await axios.post(
          `${APP_BASE_URL}/events/api/v1/participants/waiting${query}`,
          data,
        );
        if (!response?.data?.status) {
          localStorage.removeItem('waiting');
          if (response?.data?.message === "Event is ended") {
          dispatch(slice.actions.linkExpiry({
                linkExpired: true,
                expiryType: "expired",
          }));
          } else if (response?.data?.message === "Event is not started yet") {
          dispatch(slice.actions.linkExpiry({
                linkExpired: true,
                expiryType: "notStarted",
          }));
        } else if (response?.data?.message === "The given code is either invalid or expired. Please try again") {
          dispatch(slice.actions.linkExpiry({
                linkExpired: true,
                expiryType: "invalidOrCodeExpired",
          }));
        }
        else if (response?.data?.message === "Playbook is already completed") {
            dispatch(slice.actions.setPlaybookCompleted(true));
          } else if (response?.data?.message === "Event is full") {
            dispatch(
              slice.actions.linkExpiry({
                linkExpired: true,
                expiryType: "eventFull",
              }),
            );
          }
        } else {
        dispatch(slice.actions.linkExpiry({
              linkExpired: false,
              expiryType: "notStarted",
        }));
        }
        if (response?.data?.status) {
          dispatch(slice.actions.pollingToken(response?.data?.data?.token));
          return true;
        } else {
        if (response?.data?.message === "You have already running session in other browser") {
            dispatch(slice.actions.setCheckLogin(true));
            dispatch(slice.actions.setCheckMessage1(true));
        } else if (response?.data?.message === "Joining with waiting room is not allowed") {
          dispatch(slice.actions.setCheckLogin(true));
          dispatch(slice.actions.setCheckMessage1(false));
        } else if (response?.data?.message === "You're not allowed to join the event") {
          dispatch(slice.actions.setWaitingRoomNotAllowed(true));
        } else if (response?.data?.message === "Event is not published yet") {
          dispatch(slice.actions.setEventNotPublished(true));
        }
        return false;
      }
    }
    return false;
  } catch (error) {
    if (error.data.blocked) {
      dispatch(slice.actions.SetBlockUserStatus(true));
      return;
    }
    localStorage.removeItem('waiting');
    window.location.href = URL;
    return false;
  }
};

export const waiting2 = (sessionverifiedToken, id) => async (dispatch) => {
  try {
    const data = {
      eventId: id,
    };
    const config = {
      headers: { BearerToken: `${sessionverifiedToken}` },
    };
    const response = await axios.post(
      `${APP_BASE_URL}/events/api/v1/participants/waiting?forceJoin=true`,
      data,
      config
    );
    if (response?.data?.status) {
      dispatch(slice.actions.pollingToken(response?.data?.data?.token));
    } else {
      dispatch(slice.actions.setCheckLogin(true));
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const waiting3 = (id, name, email, ParticipantId) => async (
  dispatch,
) => {
    try {
      let data = {};
    if (id === '' && name === '' && email === '' && ParticipantId === '') {
      const tempData = localStorage.getItem('waiting');
        data = JSON.parse(tempData);
      } else {
        data = {
          eventId: id,
          participantId: ParticipantId,
          properties: {
            name: name,
            emailId: email,
          },
        };
      }
      if (data) {
      localStorage.setItem('waiting', JSON.stringify(data));
        const response = await axios.post(
          `${APP_BASE_URL}/events/api/v1/participants/waiting?forceJoin=true`,
          data,
        );
        if (response?.data?.status) {
          dispatch(slice.actions.pollingToken(response?.data?.data?.token));
        } else {
          dispatch(slice.actions.setCheckLogin(true));
        }
      }
    } catch (error) {
      throw new Error(error);
    }
  };

export const setCheckLogin1 = (value) => async (dispatch) => {
  dispatch(slice.actions.setCheckLogin(value));
};

let count = 0;

export const polling = (ptoken) => async (dispatch) => {
  try {
    if (count === 0 && ptoken) {
      const data = {
        token: ptoken,
      };

      const response = await axios.post(
        `${APP_BASE_URL}/events/api/v1/participants/polling`,
        data,
      );
      dispatch(slice.actions.joinStatus(response?.data?.data?.status));
      if (response?.data?.data?.status === 'accepted' && count === 0) {
        localStorage.setItem('token', response?.data?.data?.token);
        handleRefreshToken(dispatch);
        count = 1;
        localStorage.removeItem('waiting');
        dispatch(setSession(false));
        dispatch(setWaitingUser(false));
        dispatch(setAllowPermission(response?.data?.data?.role));
        if (response?.data?.data?.presentorVdi && response?.data?.data?.presentorIp) {
          dispatch(getVDIPresenter({
                presenterId: response?.data?.data?.presentorVdi,
            presenterIp: response?.data?.data?.presentorIp
          }, true));
        }
        dispatch(setConference(true));
        dispatch(handleIsCollabAvailable(response?.data?.data?.collaboration));
      } else if (response?.data?.data?.status === 'rejected' && count === 0) {
        count = 1;
        localStorage.removeItem('waiting');
      }
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const pollingAccept = (tok, num, waitingData = []) => async (
  dispatch,
) => {
    try {
      if (tok?.length === 1) {
        const data = [
          {
            token: tok[0],
            isAllowed: num,
          },
        ];

        const response = await axios.post(
          `${APP_BASE_URL}/events/api/v1/participants/accept`,
          data,
        );
        dispatch(slice.actions.finalToken(response?.data?.data?.token));
      } else if (tok?.length > 1) {
        const data = [];
        tok?.forEach(async (item) => {
          data.push({ token: item.token, isAllowed: num });
        });
        const response = await axios.post(
          `${APP_BASE_URL}/events/api/v1/participants/accept`,
          data,
        );
        dispatch(slice.actions.finalToken(response?.data?.data?.token));
      }
      dispatch(slice.actions.setDialogData({ key: false, value: waitingData }));
    } catch (error) {
      throw new Error(error);
    }
  };

export const fetchEvent = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${APP_BASE_URL}/events/api/v1/events?id=${id}`);
    dispatch(storeEventLink(res?.data?.data[0]?.inviteLink));
    dispatch(storeEventTitle(res?.data?.data[0]?.title));
    dispatch(storeEventType(res?.data?.data[0]?.type ?? ""));
    dispatch(storeVdiPresent(res?.data?.data[0]?.vdiPresent ?? false));
    dispatch(storeStudioId(res?.data?.data[0]?.studioId ?? ""));
    dispatch(meetingActions.setEnableVideo(res?.data?.data[0]?.preferences?.video));
      dispatch(meetingActions.setAllowRecording(res?.data?.data[0]?.preferences?.allowParticipantToRecord));
    dispatch(meetingActions.setMuteParticipantWhenJoining(res?.data?.data[0]?.preferences?.muteParticipantWhenJoining));
    dispatch(meetingActions.setEntryExitSound(res?.data?.data[0]?.preferences?.soundNotificationonJoinOrLeave));
    dispatch(meetingActions.setEnable360Degree(res?.data?.data[0]?.preferences?.enable360View));
    dispatch(meetingActions.setEnableGamification(res?.data?.data[0]?.preferences?.enableGamification));
    dispatch(meetingActions.setMakePlaybookCompatible(res?.data?.data[0]?.preferences?.makePlaybookCompatible));
    dispatch(meetingActions.setRecordCount(res?.data?.data[0]?.recordings?.counter));
  } catch (error) {
    throw new Error(error);
  }
};

export const fetchPublishQuestion = (contextId: string) => async () => {
  try {
    await axios.get(`${APP_BASE_URL}/events/api/v1/test/current-test`,
      {
      headers:{
        contextId:contextId
      }
    });
  } catch (error) {
    throw new Error(error);
  }
};

export const storeWaitingDialog = (data) => async (dispatch) => {
  if (
    data?.domain === 'PARTICIPANT' &&
    data?.response?.contextId === window.location.href.split('/')[4]
  ) {
    const value = {
      token: data?.response?.token,
      name: data?.response?.participant_name,
      participant_id: data?.response?.participant_id,
      participant_email: data?.response?.participant_email,
      isInvited: data?.response?.isInvited,
    };
    if (data.intent === 'PARTICIPANT_JOIN_REQUEST') {
      dispatch(slice.actions.setDialogData({ key: true, value: value }));
    } else if (data.intent === 'PARTICIPANT_JOIN_UPDATE') {
      dispatch(slice.actions.removeDialog(data?.response?.participantId));
    }
  }
};

export const insufficientCreditsDialog = (data) => async (dispatch) => {
  dispatch(
    slice.actions.storeCreditDialog({
      active: true,
      message: data.response.data.message,
      url: data.response.data.url,
    }),
  );
};

export const clearCreditDialog = () => async (dispatch) => {
  dispatch(
    slice.actions.storeCreditDialog({ active: false, message: '', url: '' }),
  );
};

export const storeInsufficientCreditsDialog = (data) => async (dispatch) => {
  dispatch(
    slice.actions.storeInsufficientCredits({
      active: true,
      message: data.response.data.message || "Insufficient Credits",
      serviceName: data.response.data.serviceName,
    }),
  );
};

export const clearInsufficientCreditsDialog = () => async (dispatch) => {
  dispatch(
    slice.actions.storeInsufficientCredits({ active: false, message: '', serviceName: '' }),
  );
};

export const hitWaitingAPI = (VIEW_ALL_PARTICIPANT) => async () => {
  try {
    if (VIEW_ALL_PARTICIPANT) {
      setTimeout(async () => {
        await axios.get(`${APP_BASE_URL}/events/api/v1/participants/waiting`);
      }, 2000);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const LeavingRoomfromWaiting = () => async (dispatch) => {
  dispatch(slice.actions.leaveBtnLoading(true));
  const LINK_EL =
    process.env.NODE_ENV !== "production"
      ? URLS.EL_LOCAL_URL
      : process.env.REACT_APP_EL_URL;
  const token = createGuest(LINK_EL);
  token.get("token", function (err, token) {
    if (err) {
      dispatch(slice.actions.leaveBtnLoading(false));
      return;
    } else {
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
      const redirectLink = localStorage.getItem("redirect");
      if (redirectLink) {
        window.location.href = `${redirectLink}`;
      } else {
        if (process.env.NODE_ENV !== 'production') {
          window.location.href = `${URLS.EL_LOCAL_URL}/${token ? 'my-learnings' : ""}`;
        } else {
          window.location.href = `${URL}/${token ? 'my-learnings' : ""}`;
        }
      }
    }
  });
};

export const redirectToBilling = () => async () => {
  if (process.env.NODE_ENV !== 'production') {
    window.location.href = `${URLS.EL_LOCAL_URL}/account/billing`;
  } else {
    window.location.href = `${URL}/account/billing`;
  }
};

export const redirectToMyLearnings = () => async () => {
  if (process.env.NODE_ENV !== 'production') {
    window.location.href = `${URLS.EL_LOCAL_URL}/my-learnings`;
  } else {
    window.location.href = `${URL}/my-learnings`;
  }
};

export const redirectToPayment = () => async () => {
  if (process.env.NODE_ENV !== 'production') {
    window.location.href = `${URLS.EL_LOCAL_URL}/subscriptions/training`;
  } else {
    window.location.href = `${URL}/subscriptions/training`;
  }
};

export const LeavingRoomAfterJoiningApp = (url: string, localUrl: string) => async () => {
    let timer = setTimeout(() => {
    if (process.env.NODE_ENV !== 'production') {
        window.location.href = localUrl;
      } else {
        // window.location.href = `${ APP_BASE_URL/event/}`;
        window.location.href = url;

      }
    }, 30000);

    // Attach event listeners to reset timer on mouse movement
  document.addEventListener('mous&emove', resetTimer);
  document.addEventListener('keydown', resetTimer);

    function resetTimer() {
      clearTimeout(timer);
      timer = setTimeout(() => {
      if (process.env.NODE_ENV !== 'production') {
          window.location.href = localUrl;
        } else {
          window.location.href = url;
        }
      }, 30000);
    }
  };


export const currentlyPresenterScreen = () => async () => {
  try {
    await axios.get(`${APP_BASE_URL}/events/api/v1/participants/get-presentor-vdi`);
  } catch (error) {
    throw new Error(error);
  }
};


export const getEventNameAPI = (eventId: string) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${APP_BASE_URL}/events/api/v1/events?id=${eventId}`
    );
    if (response?.status === 200) {
      dispatch(slice.actions.setEventName(response?.data?.data[0]?.title ?? ""));
    dispatch(meetingActions.setMuteParticipantWhenJoining(response?.data?.data[0]?.preferences?.muteParticipantWhenJoining));
    dispatch(slice.actions.setEventDataLoaded(true));
    dispatch(meetingActions.setShowTheTileAfterAgentJoins(response?.data?.data[0]?.preferences?.showTheTileAfterAgentJoins));

    } else {
      throw new Error();
    }
  } catch (error) {
    if (error?.response?.data?.message === "Invalid event Id" || error?.response?.status === 404) {
      dispatch(slice.actions.linkExpiry({
        linkExpired: true,
        expiryType: "invalidEventId",
      }));
    }
    throw new Error();
  }
};

//raise hand
export const storeReaction = (data1, raiseHand) => async (dispatch) => {
  if (raiseHand) {
    const { participantId, participantName, sequence } = data1.response;
    const value = {
      name: participantName,
      participant_id: participantId,
      sequence: sequence && sequence?.length > 0 ? sequence[0].handRaisedSequence : 0,
    };
    dispatch(slice.actions.setRaiseHandData({ data: value, raise: raiseHand }));
  } else {
    const { participantId } = data1.response;
    dispatch(slice.actions.setRaiseHandData({ data: participantId, raise: raiseHand }));
  }
};

export const participantHandDown = (data1:any) => async (dispatch:any) => {
  const token = localStorage.getItem("token");
  const tokenData: any = jwt_decode(token);
  if(data1.response.participantId === tokenData?.sub){
    dispatch(handleRaiseHandStatus(false));
  }
};


export const storeReactionClose = (data1) => async (dispatch) => {
  dispatch(slice.actions.setRaiseHandDataClose(data1));
};
const reactionTimeouts = new Map();
//user reaction
export const manageUserReaction = (data1) => async (dispatch) => {
  const participantId = data1.response.participantId;
  const value = {
    reaction: data1.response.reaction,
    participant_id: data1.response.participantId,
  };
  if (reactionTimeouts.has(participantId)) {
    clearTimeout(reactionTimeouts.get(participantId));
  }
  dispatch(slice.actions.setUserReactionData({ data: value }));
  const timeoutId = setTimeout(() => {
    dispatch(slice.actions.setUserReactionClearData(participantId));
    reactionTimeouts.delete(participantId);
  }, 3000);
  reactionTimeouts.set(participantId, timeoutId);
  // setTimeout(() => {
  //   dispatch(slice.actions.setUserReactionClearData());
  // }, 3000);
};
export const setTimeLeft = (data) => async (dispatch) => {
  dispatch(slice.actions.setTimeLeft(data));
};

export const createSession = (token, eventid) => async (dispatch) => {
  try {
    const event = {
      eventId: eventid
    };
    const response = await axios1.post(`${process.env.REACT_APP_API_URL}/aacl/api/v1/session`, event, {
      headers: { Authorization: `Bearer ${token}` }
    },);
    dispatch(slice.actions.createSession(response?.data?.data?.token));
  } catch (error) {
    throw new Error(error);
  }
};

export const getBrandingDataAPI = (id) => async (dispatch) => {

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/aacl/api/v1/branding/${id}`);
    if (res?.status === 200 && res?.data?.status) {
      const response = res?.data?.data?.branding;
      const obj = {
        enabled: response?.enabled,
        name: response?.name || "",
        tagline: response?.tagline || "",
        logo: (response?.logo && response?.enabled) ? response?.logo : process.env.REACT_APP_LOADER_LOGO,
        links: {
          privacy: (response?.links?.privacy && response?.enabled) ? response?.links?.privacy : `${process.env.REACT_APP_EL_HOMEPAGE}/en/policy/privacy`,
          terms: (response?.links?.terms && response?.enabled) ? response?.links?.terms : `${process.env.REACT_APP_EL_HOMEPAGE}/en/policy/terms-conditions`,
        },
        callback: response?.callback || "",
        customDomain: {
          enabled: response?.customDomain?.enabled || false,
          domain: response?.customDomain?.domain || "",
        },
        email: response?.email || "",
      };
      try {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          (link as HTMLLinkElement).rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }

        (link as HTMLLinkElement).href = (response?.logo && response?.enabled) ? response?.logo : process.env.REACT_APP_LOADER_LOGO;
      } catch (error) {
        throw new Error(error);
      }
      dispatch(BrandingData(obj));
    } else {
      if (res?.data?.message === "Invalid event Id") {
        dispatch(slice.actions.linkExpiry({
          linkExpired: true,
          expiryType: "invalidEventId",
        }));
      }
      dispatch(slice.actions.getBrnadingData(initialState?.branding));
      dispatch(BrandingData(initialState?.branding));
      throw new Error(res?.data?.message || "Failed to fetch branding data!");
    }
  } catch (err) {
    if (err?.response?.data?.message === "Invalid event Id") {
      dispatch(slice.actions.linkExpiry({
        linkExpired: true,
        expiryType: "invalidEventId",
      }));
    }
    dispatch(slice.actions.getBrnadingData(initialState?.branding));
    dispatch(BrandingData(initialState?.branding));
    throw new Error(err);
  }
};

export const handleParallelMeetingDialog = (data) => async (dispatch) => {
  dispatch(slice.actions.handleActivateParallelMeeting(data));
};

export const handleParticipantLimitDialog = (data) => async (dispatch) => {
  dispatch(slice.actions.handleParticipantLimit(data));
};

export const setOpenPlanUpgraded = (data) => async (dispatch) => {
  dispatch(slice.actions.setOpenPlanUpgraded(data));
};

export default slice;
